import React from "react";
import { actionTextActionMap, allowedActions } from "./common/constants";
import { checkSlaTime } from "../../services/provider/common";

const ActionsCell = ({
  nextActions,
  currentOrder,
  checkSlaOnModifiedDate,
  setActionDialogVisibility,
  setRescheduleDialogVisibility,
  setDocUploadDialogVisibility,
  setAction,
  setCurrentOrder,
  rescheduleDisable,
}) => {
  const actions = nextActions && nextActions.length ? [...new Set(nextActions.map((action) => action.action))] : null;
  const slaTime = checkSlaTime(checkSlaOnModifiedDate ? currentOrder.modifiedOn : currentOrder.fulfillmentDate, 4);
  const rescheduleDisableTime = checkSlaTime(currentOrder.fulfillmentDate, 2);
  rescheduleDisable = rescheduleDisableTime ? true : rescheduleDisable;
  const applicableActions = actions ? actions.filter((value) => allowedActions.includes(value)) : null;

  const handleClickAction = (event, action) => {
    if (action == "Reschedule") {
      setRescheduleDialogVisibility(true);
    } else if (action == "Upload Rx") {
      setDocUploadDialogVisibility(true);
    } else {
      setAction(action);
      setActionDialogVisibility(true);
    }
    setCurrentOrder(currentOrder);
  };

  return (
    <div>
      {applicableActions?.length ? (
        <>
          <div className="text-xs flex al-itm-bs">
            {applicableActions.map((action) => (
              <button
                className={
                  rescheduleDisable && action == "Reschedule"
                    ? "border border-gray-400  bg-gray-400 text-gray-100 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-default ml-2 mb-2"
                    : "border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-pointer ml-2 mb-2"
                }
                onClick={(event) => handleClickAction(event, actionTextActionMap[action])}
                disabled={rescheduleDisable && action == "Reschedule"}
              >
                {actionTextActionMap[action]}
              </button>
            ))}
          </div>
          {slaTime && (
            <div className="pt-1 text-center w-full font-normal mt-1 bg-red-100 rounded" style={{ fontSize: "12px" }}>
              <div className="animateSLACount">Action Pending Since</div>
              <div className="animateSLACount">
                {slaTime.month ? (
                  <span>{slaTime.month} Month</span>
                ) : slaTime.day ? (
                  <span>
                    {slaTime.day} Day{slaTime.hour ? `s ${slaTime.hour} Hours` : ""}
                  </span>
                ) : slaTime.hour ? (
                  <span>{slaTime.hour} Hour</span>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div>No Actions Allowed</div>
      )}
    </div>
  );
};

export default ActionsCell;
